// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer-container {
  background-color: #0f6325;
  font-family: Manrope;
  align-items: center;
}

.list {
  list-style: none;
  padding: 0px;
  text-align: left;
  margin: 0;
}
.list a {
  text-decoration: none;
  color: white;
}
.copy-right {
  /* background-color: #555555; */
  border-top: 0.7px solid #ffffff;
}
.footer-text {
  color: white;
}

.footer-logo {
  max-width: 125px;
}
.fssailogo {
  max-width: 100px;
}
/* -----------------------------  footer  ----------------------------------------- */
.footer-bg {
  background-color: #0f6325;
  color: white;
}
.footer-text {
  font-weight: 400;
  font-size: 12px;
  line-height: 24px;
}
.footer-text-right {
  font-weight: 700;
  font-size: 16px;
  color: white;
}
.footer-btn-app-link {
  color: white;
  border: 0.5px solid white;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  background-color: transparent;
  border-radius: 5px;
  min-width: 100px;
  width: 100%;
  padding-top: 10px;
  padding-bottom: 10px;
  cursor: pointer;
  transition: border-color 0.25s;
}

.footer-btn-app-link:hover {
  background-color: #75a66f;
}
.credit-text {
  font-size: 12px;
  font-weight: 400;
  color: #f5f5f5;
}

.footer-link {
  font-family: "Manrope", sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #fff;
  text-decoration: none;
}
.footer-heading-links {
  color: white;
  font-size: 18px;
  font-weight: 700;
  font-family: "Manrope", sans-serif;
}

.input-footer {
  border-radius: 0px !important;
}
.subscribe-button {
  border-radius: 0px !important;
  background-color: #28af4b !important;
  color: white !important;
  padding: 0.6em 1.2em;
  cursor: pointer;
  transition: border-color 0.25s;
}

.footer-credit-text-div {
  border-top: 0.7px solid #699d77;
}
.footer-credit-text {
  font-size: 12px;
  font-weight: 400;
  color: #f5f5f5;
}

.footeractive {
  color: #20e954 !important;
  font-weight: 700;
}
/* -----------------------------  footer  ----------------------------------------- */
`, "",{"version":3,"sources":["webpack://./src/components/footer/Footer.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,qBAAqB;EACrB,YAAY;AACd;AACA;EACE,+BAA+B;EAC/B,+BAA+B;AACjC;AACA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA,qFAAqF;AACrF;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;EAC7B,oCAAoC;EACpC,uBAAuB;EACvB,oBAAoB;EACpB,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;AACA,qFAAqF","sourcesContent":[".footer-container {\n  background-color: #0f6325;\n  font-family: Manrope;\n  align-items: center;\n}\n\n.list {\n  list-style: none;\n  padding: 0px;\n  text-align: left;\n  margin: 0;\n}\n.list a {\n  text-decoration: none;\n  color: white;\n}\n.copy-right {\n  /* background-color: #555555; */\n  border-top: 0.7px solid #ffffff;\n}\n.footer-text {\n  color: white;\n}\n\n.footer-logo {\n  max-width: 125px;\n}\n.fssailogo {\n  max-width: 100px;\n}\n/* -----------------------------  footer  ----------------------------------------- */\n.footer-bg {\n  background-color: #0f6325;\n  color: white;\n}\n.footer-text {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 24px;\n}\n.footer-text-right {\n  font-weight: 700;\n  font-size: 16px;\n  color: white;\n}\n.footer-btn-app-link {\n  color: white;\n  border: 0.5px solid white;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 20px;\n  background-color: transparent;\n  border-radius: 5px;\n  min-width: 100px;\n  width: 100%;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  cursor: pointer;\n  transition: border-color 0.25s;\n}\n\n.footer-btn-app-link:hover {\n  background-color: #75a66f;\n}\n.credit-text {\n  font-size: 12px;\n  font-weight: 400;\n  color: #f5f5f5;\n}\n\n.footer-link {\n  font-family: \"Manrope\", sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  color: #fff;\n  text-decoration: none;\n}\n.footer-heading-links {\n  color: white;\n  font-size: 18px;\n  font-weight: 700;\n  font-family: \"Manrope\", sans-serif;\n}\n\n.input-footer {\n  border-radius: 0px !important;\n}\n.subscribe-button {\n  border-radius: 0px !important;\n  background-color: #28af4b !important;\n  color: white !important;\n  padding: 0.6em 1.2em;\n  cursor: pointer;\n  transition: border-color 0.25s;\n}\n\n.footer-credit-text-div {\n  border-top: 0.7px solid #699d77;\n}\n.footer-credit-text {\n  font-size: 12px;\n  font-weight: 400;\n  color: #f5f5f5;\n}\n\n.footeractive {\n  color: #20e954 !important;\n  font-weight: 700;\n}\n/* -----------------------------  footer  ----------------------------------------- */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
